<template>
	<div class="centerWidth">
		<div class="gaokao-nav">
			<span @click="goMyCenter">个人中心 ></span>
			<span>查.省控分数线</span>
		</div>
		<section class="gaokao-content" style="padding-bottom: 60px;">
			<article class="major-share">
				<ul>
					<li class="flex wrap">
						<label>招生地区：</label>
						<div class="fenNum_div">
							<!-- <p :class="currCityName == '' ? 'on' : ''" @click="cityClick('')">全部</p> -->
							<p :class="item.Name == currCityName ? 'on' : ''" @click="cityClick(item.Name)"
								v-for="(item, index) in cityList" :key="index">{{ item.Name }}</p>
						</div>
					</li>
				</ul>
			</article>
			<div style="overflow: hidden;">
				<article class="table">
					<h6>省控线分数表:</h6>
					<!--23.1.10 <hgroup class="flex" style="background-color: #f2f2f2;">
						<p style="width: 105px;text-align: left;"></p>
						<p v-for="(item, index) in typeList" :key="index">{{ item.year }}</p>
					</hgroup> 
				
                     <ul>
						<li class="flex" style="background-color: #f2f2f2;border-top: solid 1px #e6e6e6;">
							<p style="width: 105px;text-align: left;">批次/科类</p>
							<div class="li_dd flex">
								<p v-for="(item, index) in typeList" :key="index">{{ item.type }}</p>
							</div>
						</li>
						<li class="flex" v-for="(item, index) in lineList" :key="index">
							<p style="width: 105px;text-align: left;">{{ item.Batch }}</p>
							<div class="li_dd flex">
								<p v-for="(item2, index2) in item.SocreList" :key="index2">{{ item2 }}</p>
							</div>
						</li>
					</ul> -->
					<!-- 新修改 -->
					<ul>
						<li class="flex ptkuan" style="background-color: #f2f2f2;border-top: solid 1px #e6e6e6;">
							<p>年份</p>
							<p>考生类别</p>
							<p>批次名称</p>
							<p>省份分数线</p>
							<p>位次</p>
						</li>
						<li class="flex ptkuan" v-for="(item, index) in scoreList" :key="index">
							<p>{{ item.Year }}</p>
							<p>{{ item.CandidatesType }}</p>
							<p>{{ item.Batch }}</p>
							<p>{{ item.Socre }}</p>
							<p>{{ item.Rank }}</p>
						</li>

					</ul>
				</article>
			</div>
			<!-- <div style="overflow: hidden;margin-top: 30px;">
				<article class="table">
					
					<hgroup class="flex" style="background-color: #f2f2f2;">
						<p style="width: 105px;text-align: left;"></p>
						<p v-for="(item, index) in typeList" :key="index">{{ item.year }}</p>
					</hgroup>
					<ul>
						<li class="flex" style="background-color: #f2f2f2;border-top: solid 1px #e6e6e6;">
							<p style="width: 105px;text-align: left;">批次/科类</p>
							<div class="li_dd flex">
								<p v-for="(item, index) in typeList" :key="index">{{ item.type }}</p>
							</div>
						</li>
						<li class="flex" v-for="(item, index) in lineList" :key="index">
							<p style="width: 105px;text-align: left;">{{ item.Batch }}</p>
							<div class="li_dd flex">
								<p v-for="(item2, index2) in item.RankList" :key="index2">{{ item2 }}</p>
							</div>
						</li>
					</ul>
				</article>
			</div> -->
		</section>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				typeList: [],
				lineList: [],
				// 以上2.13
				isCity: 0,
				cityList: [],
				subjectName: '',
				totleNum: 0,
				page: 1,
				pageSize: 10,
				CollegeList: [],
				currCityName: '',
				candidatesType: '',
				scoreList: []
			};
		},
		// 加载
		created() {
			this.$store.state.shop.currentProvince.map(ent => {
				if (ent.Code === this.$store.state.user.user.ProvinceCode.toString()) {
					this.cityList.push(ent);
				}
			});
			if (this.cityList.length > 0) {
				this.currCityName = this.cityList[0].Name;
			}
			this.GetList();
			if (this.$route.query.key) {
				this.$api.reduceUserCount({
					key: this.$route.query.key
				});
			} else {
				this.$router.back(-1);
			}
		},
		methods: {
			// 个人中心
			goMyCenter() {
				this.$router.push('/myIndex');
			},

			cityClick(name) {
				if (this.currCityName !== name) {
					this.currCityName = name;
					this.GetList(1);
				}
			},
			// 获取代理城市
			GetCity: function() {
				var that = this;
				that.$api.HtppRequest(
					'SystemData/GetShopCity',
					'GET', {},
					function(res) {
						console.log('获取代理城市', res);
						if (res.flag) {
							that.cityList = res.list;
							if (that.cityList.length > 0) {
								this.currCityName = that.cityList[0].Name;
							}
							this.GetList(1);
						}
					},
					function(err) {
						console.log(err);
					}
				);
			},
			// 获取列表
			GetList: function() {
				var that = this;
				that.$api.HtppRequest(
					'SystemData/NewProvincialLine',
					'GET', {},
					function(res) {
						console.log('获取列表', res);
						if (res.code === 0) {
							that.lineList = res.data.list;
							if (that.lineList.length > 0) {
								that.lineList = that.lineList.map(t => {
									t.SocreList = [];
									t.RankList = [];
									if (t.Years.length > 0) {
										t.Years.map(y => {
											if (y.Data.length > 0) {
												y.Data.map(d => {
													t.SocreList.push(d.Socre);
													t.RankList.push(d.Rank);
												});
											}
											return y;
										});
									}
									return t;
								});
							}
							var year = res.data.year;
							var candidatesType = res.data.candidatesType;
							var typeList = [];
							if (year.length > 0 && candidatesType.length > 0) {
								year.map(a => {
									candidatesType.map(b => {
										typeList.push({
											year: a,
											type: b
										});
									});
								});
							}
							that.typeList = typeList;

							// 2023-1-13 重新组合省控分数表数据，前端显示结构发生变化了
							var list = res.data.list;
							var newList = [];
							if (list.length > 0) {
								list.map(a => {
									if (a.Years.length > 0) {
										a.Years.map(b => {
											if (b.Data.length > 0) {
												b.Data.map(c => {
													newList.push({
														CandidatesType: c
															.CandidatesType,
														Id: c.Id,
														Rank: c.Rank,
														Socre: c.Socre,
														Year: b.Year,
														Batch: a.Batch,
													})
												})
											}
										})
									}
								})
							}
							// 按年份排序
							var sortList=[];
							if(res.data.year.length>0)
							{
								res.data.year.map(a=>{
									if(newList.length>0)
									{
										newList.map(b=>{
											if(b.Year==a)
											{
												sortList.push(b);
											}
										})
									}
									
								})
							}
							that.scoreList = sortList;


						}
					},
					function(err) {
						console.log(err);
					}
				);
			},
			// 获取其他页
			GetPageList: function(val) {
				var that = this;
				that.GetList(val);
				console.log(`当前页: ${val}`);
			}
		}
	};
</script>
<style scoped>
	.table ul li>p:first-child {
		padding: 0 10px;
	}

	.table>h6 {
		padding: 0 10px;
		line-height: 45px;
		background-color: #f2f2f2;
		font-size: 14px;
		color: #000;
		border-bottom: solid 1px #e6e6e6;
	}

	.table li p {
		font-size: 14px;
		line-height: 50px;
		text-align: center;
		padding: 0 4px;
		box-sizing: border-box;
		border-right: solid 1px #e6e6e6;
	}

	.table li p:last-child {
		border-right: none;
	}

	.li_dd {
		width: calc(100% - 105px);
	}

	.li_dd p {
		width: 105px;
	}

	.table li:last-child {
		border-bottom: none;
	}

	.table li p:last-child {
		border-right: none;
	}

	.table li {
		border-bottom: solid 1px #e6e6e6;
	}

	.table ul {
		overflow: hidden;
	}

	.table hgroup p:last-child {
		border-right: none;
	}

	.table hgroup p {
		font-size: 14px;
		border-right: solid 1px #e6e6e6;
		background-color: #f2f2f2;
		width: 105px;
		/* width: calc((100% - 105px) / 15); */
		line-height: 60px;
		text-align: center;
		padding: 0 10px;
		box-sizing: border-box;
	}

	.table {
		overflow: hidden;
		border: solid 1px #e6e6e6;
		box-sizing: border-box;
	}

	/* 01 */
	.fenNum_div p {
		width: 78px;
		height: 40px;
		line-height: 40px;
		float: left;
		color: #333;
		font-size: 14px;
		margin-right: 20px;
		text-align: center;
		border-radius: 4px;
		cursor: pointer;
	}

	.fenNum_div p:hover {
		opacity: 0.7;
	}

	.fenNum_div p.on:hover {
		opacity: 1;
	}

	.fenNum_div p.on {
		background-color: #333;
		color: #fff;
	}

	.fenNum_div {
		width: calc(100% - 200px);
		margin-left: 20px;
	}

	.major-share label {
		font-size: 14px;
		color: #333;
		display: block;
		width: 100px;
		line-height: 40px;
		text-align: right;
	}

	.major-share ul li:first-child {
		margin-top: 0;
	}

	.major-share ul li {
		margin-top: 20px;
	}

	.major-share ul {
		overflow: hidden;
	}

	/* major-share */

	.gaokao-btn {
		width: 90px;
		font-size: 14px;
		margin-left: 0 !important;
	}

	.fenNum_head p.on {
		background-color: #333;
		color: #fff;
	}

	.fenNum_head p.on:hover {
		opacity: 1;
	}

	.fenNum_head p {
		font-size: 16px;
		color: #333;
		width: 180px;
		height: 38px;
		border-top-left-radius: 4px;
		border-top-right-radius: 4px;
		float: left;
		border: solid 1px #333;
		border-bottom: none;
		text-align: center;
		line-height: 38px;
		cursor: pointer;
	}

	.fenNum_head p:hover {
		opacity: 0.7;
	}

	.fenNum_head {
		overflow: hidden;
		border-bottom: solid 2px #333;
		margin-top: 40px;
	}

	/* fenNum_head */

	.gaokao-nav {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 20px 0;
	}

	.gaokao-nav span {
		font-size: 15px;
		color: #333;
	}

	.gaokao-nav span:last-child {
		color: #333;
	}

	/* gaokao-content */
	.gaokao-content {
		padding: 0 20px;
		width: 100%;
		height: auto;
		overflow: hidden;
		background-color: #fff;
		margin-bottom: 25px;
	}

	/* major-share */
	.major-share {
		width: 100%;
		height: auto;
		overflow: hidden;
		background-color: #f2f2f2;
		margin: 20px auto 30px auto;
		padding: 30px 0;
	}

	.major-share-con {
		width: 75%;
		height: auto;
		overflow: ;
		display: flex;
		flex-wrap: wrap;
	}

	.share-li {
		width: 50%;
		display: flex;
		align-items: center;
		/* justify-content: center; */
		margin: 10px 0;
	}

	.share-li p {
		font-size: 14px;
		color: #333;
		width: 100px;
		text-align: right;
		margin-right: 20px;
	}

	.share-li input {
		width: 270px;
		height: 40px;
		line-height: 40px;
		padding: 0 10px;
		display: block;
		border-radius: 5px;
		background-color: #fff;
		color: #333;
		font-size: 14px;
	}

	.share-li input::-webkit-input-placeholder {
		color: #999;
	}

	.share-li input:-moz-placeholder {
		color: #999;
	}

	.share-li input:-ms-input-placeholder {
		color: #999;
	}

	.sjWidth {
		width: 270px;
	}

	.major-btn01 {
		width: 25%;
		display: flex;
		align-items: flex-end;
	}

	.major-btn01 button {
		margin: 10px auto;
	}

	/* major-list */
	.major-list {
		width: 100%;
		height: auto;
		margin-top: 15px;
	}

	.major-list ul {
		width: 100%;
		height: auto;
	}

	.major-list ul li {
		border: 1px solid #eee;
		width: 100%;
		height: auto;
		padding: 20px 30px;
		margin-bottom: 20px;
		position: relative;
	}

	.major-li01 {
		width: 100%;
		height: auto;
		display: flex;
		align-items: center;
	}

	.major-li-btn {
		width: 23%;
	}

	.major-li-btn p {
		width: 130px;
		height: 33px;
		line-height: 33px;
		text-align: center;
		background-color: #333;
		font-size: 16px;
		color: #fff;
		border-radius: 50px;
	}

	.major-li01-right {
		width: 80%;
		display: flex;
	}

	.major-li01-right p {
		width: 20%;
		display: flex;
		align-items: center;
		line-height: 33px;
	}

	.major-li01-right p span {
		font-size: 15px;
		color: #999;
	}

	.major-li01-right p span:last-child {
		color: #333;
	}

	.major-li02 {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
	}

	.major-li02 p {
		font-size: 14px;
	}

	.major-txt01 {
		width: 75px;
		color: #999;
	}

	.major-txt02 {
		width: calc(100% - 120px);
		color: #333;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.major-more {
		width: 45px;
		color: #333;
		text-align: right;
		cursor: pointer;
	}

	.major-txt04 {
		color: #333;
	}

	.major-more-con {
		position: absolute;
		width: 98%;
		height: auto;
		background: rgba(0, 0, 0, 0.7);
		padding: 20px;
		font-size: 15px;
		color: #fff;
		left: 1%;
		bottom: 0;
		border-radius: 5px;
		margin-bottom: -14px;
		z-index: 1;
	}

	.major-more-con::after {
		position: absolute;
		content: '';
		right: 0;
		top: 0;
		width: 0;
		height: 0;
		border-left: 8px solid transparent;
		border-right: 8px solid transparent;
		border-bottom: 14px solid rgba(0, 0, 0, 0.7);
		margin-top: -14px;
		margin-right: 24px;
	}

	.major-page {
		margin-bottom: 30px;
	}

	.widthx {
		margin-top: 20px;
		margin-bottom: 10px;
	}

	.widthx .major-li01-right {
		width: 100%;
	}

	.widthx .major-li01-right p:first-child {
		min-width: 22.2%;
	}

	.widthx .major-li01-right p:nth-child(2) {
		width: 32.3%;
	}

	.lastIndex .major-li01-right p {
		width: 35%;
	}

	.ptkuan p {
		width: 20%
	}
</style>
